// Configuration du site fibra.mis-gestiones-luz.es : identité, horaires, textes, Google.
// Numéros : config/phoneConfig.js · Opérateurs et URL d'annonces : config/providersData.js
// Textes en espagnol : guillemets doubles uniquement (une apostrophe dans une chaîne entre apostrophes casse le build).
import { PHONES } from "./phoneConfig";
import { PROVIDERS, HOME_ALIASES } from "./providersData";

export const SITE = {
  key: "fibra",
  domain: "https://fibra.mis-gestiones-luz.es",
  brandName: "Mis Gestiones Luz",
  siteLabel: "fibra.mis-gestiones-luz.es",
  logoTop: "mis gestiones",
  logoBottom: "fibra y móvil",
  themeColor: "#1F3C88",

  phones: PHONES,

  // Mêmes horaires partout (pages, pied de page, FAQ, extensions et annonces).
  hours: "de lunes a viernes de 9:00 a 21:00 y los sábados de 9:00 a 18:00",

  company: {
    name: "NOMA CREATIVA S.L.",
    form: "sociedad de responsabilidad limitada unipersonal, con un capital social de 3.000 €",
    cif: "B75294942",
    register: "inscrita en el Registro Mercantil de Barcelona, hoja B-660273",
    address: "Ronda General Mitre 126, 6.ª planta, 08021 Barcelona (España)",
    phone: "+34 930 52 37 15", // numéro administratif : texte simple, jamais en lien tel:
    email: "contact@mis-gestiones-luz.es",
    privacyEmail: "contact@mis-gestiones-luz.es",
  },
  emailResponse: "en un plazo de 72 horas laborables",

  vertical: {
    product: "de fibra y móvil",
    partner: "un socio especializado en la contratación de ofertas de fibra y móvil",
    notA: "ni un operador de telecomunicaciones ni un proveedor de acceso a internet",
    eyebrow: "Comparador de ofertas de fibra y móvil",
    homeTitle: "Compara las ofertas de fibra y móvil",
    homeSub:
      "Un asesor compara por teléfono las ofertas de fibra y móvil de nuestros operadores asociados según tus usos y te ayuda a contratar la que elijas.",
    bullets: [
      "Comparación gratuita de las ofertas de nuestros socios",
      "Ofertas de fibra, móvil y fibra con móvil",
      "Cambio de operador acompañado por un asesor",
    ],
    savingsTitle: "Reduce tu factura de fibra y móvil",
    savingsText:
      "Una oferta más adecuada a tus usos puede bajar tu factura. El asesor te explica los pasos para cambiar de operador.",
    seoTitle: "Comparar ofertas de fibra y móvil",
    seoDescription:
      "Mis Gestiones Luz compara por teléfono las ofertas de fibra y móvil de sus operadores asociados. Servicio de comparación gratuito.",
    existingContract: "factura, baja, reclamación o incidencia técnica",
    supplierWord: "operador",
    ourSuppliers: "nuestros operadores asociados",
    supplierSelection: "una selección de operadores asociados",
    byTheSuppliers: "por los operadores",
    areYouQuestion: "¿Sois un operador de telefonía?",
  },

  // Pas d'encadré urgences sur le site fibra.
  emergency: null,

  // Couleurs de l'accueil et des pages sans couleur de marque.
  defaultTheme: { primary: "#1F3C88", secondary: "#2F80ED" },

  providers: PROVIDERS,
  homeAliases: HOME_ALIASES,

  // Identifiant Google Ads (AW-XXXXXXX) à renseigner si une balise doit être chargée après consentement.
  googleTagId: "",
};
